module.exports = __webpack_public_path__ + "media/images/lp/lp12-86cc08317aacf3adad186028c60efa86.webp";